import { render, staticRenderFns } from "./U_VideoBussiness.vue?vue&type=template&id=f21527a2&scoped=true&"
import script from "./U_VideoBussiness.vue?vue&type=script&lang=js&"
export * from "./U_VideoBussiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21527a2",
  null
  
)

export default component.exports